import React from 'react';
import { useSelector } from 'react-redux';
import { Divider, makeStyles, Grid, Avatar, Box, IconButton, Typography, Button } from '@material-ui/core';
import BackNextButtonContainer from '../BackNextButtonContainer';
import ManageAssetInNewTabLink from '../../ManageAsset/ManageAssetInNewTabLink';
import { jiraDomainUrl } from '../../../Constants/Api';
import { orderBy } from 'lodash';

//constants
const infoTxt =
	'Your 3D Assets have been created! Use the Create More Assets button to create more assets or use the Manage links to go to each asset and view/edit them.';
const avatarTxt = 'Asset';
const assetsCreatedLblTxt = 'Assets Created';

const useStyles = makeStyles((theme) => ({
	avatarSize: {
		width: '4em',
		height: '4em',
	},
	field: {
		fontWeight: 'bold',
	},
}));
const JiraBtn = ({ jiraTask }) => {
	if (jiraTask) {
		const jiraLink = `${jiraDomainUrl}${jiraTask}`;
		return (
			<Button variant="outlined" color="primary" href={jiraLink} target="_blank" size="small">
				{`Jira: ${jiraTask}`}
			</Button>
		);
	}
	return null;
};
const ReviewAndSubmitAssetSuccess = () => {
	const assets = useSelector((state) => state.submittedAssets);
	// Sort assets with no JIRA's to the top.
	const sortedAssets = orderBy(assets, ['jiraTask'], ['desc']);
	const classes = useStyles();
	return (
		<Grid item xs={10} data-cy="created-assets-container">
			<Typography variant="body1">{assetsCreatedLblTxt}</Typography>
			<Box pt={2}></Box>
			<Typography>{infoTxt}</Typography>
			<Box pt={2}></Box>
			<Grid container>
				<BackNextButtonContainer></BackNextButtonContainer>
			</Grid>
			<Box pt={2}></Box>
			<Divider></Divider>
			{sortedAssets.map((asset) => {
				const { jiraTask } = asset;
				return (
					<Grid container key={asset.id} spacing={2} alignItems="center">
						<Grid item xs={12}>
							<Box p={2}></Box>
						</Grid>
						<Grid item xs={6}>
							<Grid container alignItems="center">
								<Grid item xs={4}>
									<Avatar variant="square" className={classes.avatarSize}>
										<Typography>{avatarTxt}</Typography>
									</Avatar>
								</Grid>
								<Grid item xs={6}>
									<div>
										<Typography>
											<span className={classes.field}>Name:</span>
											{asset.name}
										</Typography>
										<Typography>
											<span className={classes.field}>ID:</span>
											{asset.id}
										</Typography>
									</div>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={2}>
							<IconButton size="small" color="primary">
								<ManageAssetInNewTabLink
									assetUUID={asset.id}
									linkTxt={'Manage'}
								></ManageAssetInNewTabLink>
							</IconButton>
						</Grid>
						<Grid item xs={2}>
							<JiraBtn jiraTask={jiraTask} />
						</Grid>
						<Grid item xs={12}>
							<Box p={2}></Box>
							<Divider></Divider>
						</Grid>
					</Grid>
				);
			})}
		</Grid>
	);
};

export default ReviewAndSubmitAssetSuccess;
